import React, { useEffect, useState } from "react";
import { useSelector } from "react-redux";

import { Check } from "@material-ui/icons";
import DataTable from "../../../components/data-table";
// import FormModalContent from "./form";
import { useMemo } from "react";
import reqGlassesService from "../../../services/req-glasses.service";
import cartInquiryService from "../../../services/cart-inquiry.service";
import ConfirmCartInquiryModal from "./confirmModal";

const defaultKeys = [
    //   {
    //     title: "شماره تلفن",
    //     field: "user.phoneNumber",
    //     active: true,
    //   },
];

const statusEnum = [
    { key: "pending", value: "pending", title: "در انتظار پاسخ" },
    { key: "answerd", value: "answerd", title: "پاسخ داده شده" },
]

export default function CartInquiryPage() {
    const { initials } = useSelector((state) => state.app);

    const [data, setData] = useState([]);
    const [filter, setFilter] = useState({
        status: "pending"
    })

    const headerCells = useMemo(
        () => [
            {
                field: "user",
                title: "کاربر",
                disableSort: true,
                renderer: (v) => v.fullName,
            },
            {
                field: "user",
                title: "شماره تلفن",
                disableSort: true,
                renderer: (v) => <span className="en">{v.phoneNumber}</span>,
            },
            {
                field: "status",
                title: "وضعیت",
                disableSort: true,
                renderer: (v) => statusEnum.find(item => item.value === v)?.title ?? ""
            },
            {
                field: "createDate",
                title: "تاریخ درخواست",
                date: true,
                mainField: true,
            },
        ],
        [initials]
    );

    const getRequests = async () => {
        const res = await cartInquiryService.getCartInquiry(filter.status);
        setData(res.data);
    }

    useEffect(() => {
        getRequests()
    }, [filter])

    return (
        <div className="p-3">
            <DataTable
                title="درخواست موجودی"
                orderBy="createDate"
                headCells={headerCells}
                data={data}
                onRefresh={getRequests}
                rowActions={[
                      {
                        modalProps: { maxWidth: "lg" },
                        icon: <Check />,
                        hidden: (row) => row.status !== "pending",
                        modalContent: (props) => <ConfirmCartInquiryModal {...props} doRefresh={getRequests} />,
                      },
                ]}
                searchKeys={defaultKeys}
                filterForm={{
                    handleSubmit: (newFilter) => {
                        setFilter(prev => ({
                            ...prev, 
                            status: newFilter.status
                        }))
                    },
                    form: [
                        {
                            _type: "autocomplete",
                            _empty: "pending",
                            name: "status",
                            options: statusEnum,
                            valueSelector: "value",
                            labelSelector: "title",
                            label: "وضعیت",
                            disableClearable: true,

                        },
                    ],
                }}
            />
        </div>
    );
}
